// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

//ENUMS
// eslint-disable-next-line no-unused-vars
import { AdminRole } from "@/enums/AdminRoles.js";

// ## Admin Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, roleType: AdminRole }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Admin.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Admin Create
/**
 *
 * @param {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": AdminRole}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Admin.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Admin Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Admin.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Admin Update
/**
 *
 * @param  {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": AdminRole}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Admin.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Admin Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Admin.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export const ResetPassword = async (form) => {
  const response = await $api.post(Endpoints.Admin.ResetPassword(), {
    token: form.token,
    password: form.password,
  });
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  ResetPassword,
};
